import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F2.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame2() {
    let [isLoading, setIsLoading] = useState(false)
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, [])

    if (isLoading === true) {
        return (<div className="F1_image"></div>)
    } else {
        return (
            <div className="F2_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F2_entryBox">
                    <div className="F2_paragraph">
                        {language === 'english' ?
                            <p className="F2_paragraphEnglish">Saira is a young girl, about to enter into her teens. Saira goes to a nearby school. She is cheerful and has many friends. Her best friend, however, is Maria who is also her neighbor. Saira is one of the brightest girls in her class and she is equally active in extracurricular activities.</p>
                            :
                            <p className="F2_paragraphUrdu">سائرا ایک نوعمر لڑکی ہے، جو کہ اپنے لڑکپن کے قریب ہے۔ سائرا قریب کے اسکول جاتی ہے، وہ بہت خوش مزاج ہے اور اس کی بہت ساری سہیلیاں ہیں، لیکن ماریہ، جو اس کی پڑوسی بھی ہے، اس کی سب سے قریبی دوست ہے۔ سائرا پنی کلاس میں پرھائی میں سب سے آگے ہے اور کھیل کود میں بھی سرگرم ہے۔</p>
                        }
                    </div>

                    <div className="F2_timeline">
                        <div className='F2_timelineBar'>
                            <div className='F2_timelineFill'></div>
                            <span className='F2_timelineText'>2/16</span>
                        </div>
                    </div>

                    <div className="F2_nextFrames">
                        <div className="F2_nextFrame1"></div>
                        <div className="F2_nextFrame2"></div>
                        <div className="F2_nextFrame3"></div>
                    </div>

                    <div className='F2_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp());  dispatch(set_ep1_lastVisitFrame(2)) }} className='F2_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame2;